import {
    FETCH_START,
    FETCH_END,
    CREATE_PERIOD_DEFINITION_START,
    CREATE_PERIOD_DEFINITION_SUCCESS,
    CREATE_PERIOD_DEFINITION_FAIL,
    GET_PERIODS_START,
    GET_PERIODS_SUCCESS,
    GET_PERIODS_FAIL,
    GET_PERIOD_BY_ID_START,
    GET_PERIOD_BY_ID_SUCCESS,
    GET_PERIOD_BY_ID_FAIL,
    UPDATE_PERIOD_START,
    UPDATE_PERIOD_SUCCESS,
    UPDATE_PERIOD_FAIL,
    DELETE_PERIOD_START,
    DELETE_PERIOD_SUCCESS,
    DELETE_PERIOD_FAIL,
    GENERATE_PERIODS_START,
    GENERATE_PERIODS_SUCCESS,
    GENERATE_PERIODS_FAIL,
    GET_PERIODS_BY_NAME_YEAR_START,
    GET_PERIODS_BY_NAME_YEAR_SUCCESS,
    GET_PERIODS_BY_NAME_YEAR_FAIL,
    CLEAR_SELECTED_PERIOD,
} from '../../actions/Calendar/ActionTypes';

const initialState = {
    loading: false,
    periods: [],
    selectedPeriod: null,
    generatedPeriods: [],
    periodsByNameYear: [],
    error: null,
    successMessage: null,
};

const CalendarReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return {
                ...state,
                loading: true,
                error: null,
                successMessage: null,
            };
        case FETCH_END:
            return {
                ...state,
                loading: false,
            };

        case CREATE_PERIOD_DEFINITION_START:
            return {
                ...state,
                loading: true,
                error: null,
                successMessage: null,
            };
        case CREATE_PERIOD_DEFINITION_SUCCESS:
            // Only add to periods if data has required fields, otherwise getPeriods() will refresh it
            const shouldAddToPeriods = action.data && action.data.id && action.data.name;
            return {
                ...state,
                periods: shouldAddToPeriods
                    ? [...state.periods, action.data]
                    : state.periods,
                selectedPeriod: action.data,
                loading: false,
                error: null,
                successMessage: action.message || 'Period definition created successfully',
            };
        case CREATE_PERIOD_DEFINITION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                successMessage: null,
            };

        case GET_PERIODS_START:
            return {
                ...state,
                loading: true,
                error: null,
                successMessage: null,
            };
        case GET_PERIODS_SUCCESS:
            return {
                ...state,
                periods: action.data,
                loading: false,
                error: null,
                successMessage: null,
            };
        case GET_PERIODS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                successMessage: null,
            };

        case GET_PERIOD_BY_ID_START:
            return {
                ...state,
                loading: true,
                error: null,
                successMessage: null,
            };
        case GET_PERIOD_BY_ID_SUCCESS:
            return {
                ...state,
                selectedPeriod: action.data,
                loading: false,
                error: null,
            };
        case GET_PERIOD_BY_ID_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                successMessage: null,
            };

        case UPDATE_PERIOD_START:
            return {
                ...state,
                loading: true,
                error: null,
                successMessage: null,
            };
        case UPDATE_PERIOD_SUCCESS:
            return {
                ...state,
                periods: state.periods.map((period) =>
                    period.id === action.data.id ? action.data : period
                ),
                selectedPeriod: action.data,
                loading: false,
                error: null,
                successMessage: action.message || 'Period updated successfully',
            };
        case UPDATE_PERIOD_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                successMessage: null,
            };

        case DELETE_PERIOD_START:
            return {
                ...state,
                loading: true,
                error: null,
                successMessage: null,
            };
        case DELETE_PERIOD_SUCCESS:
            return {
                ...state,
                periods: state.periods.filter((period) => period.id !== action.id),
                selectedPeriod:
                    state.selectedPeriod?.id === action.id
                        ? null
                        : state.selectedPeriod,
                loading: false,
                error: null,
                successMessage: 'Period deleted successfully',
            };
        case DELETE_PERIOD_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                successMessage: null,
            };

        case GENERATE_PERIODS_START:
            return {
                ...state,
                loading: true,
                error: null,
                successMessage: null,
            };
        case GENERATE_PERIODS_SUCCESS:
            return {
                ...state,
                generatedPeriods: action.data,
                loading: false,
                error: null,
                successMessage: 'Periods generated successfully',
            };
        case GENERATE_PERIODS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                successMessage: null,
            };

        case GET_PERIODS_BY_NAME_YEAR_START:
            return {
                ...state,
                loading: true,
                error: null,
                successMessage: null,
            };
        case GET_PERIODS_BY_NAME_YEAR_SUCCESS:
            return {
                ...state,
                periodsByNameYear: action.data,
                loading: false,
                error: null,
            };
        case GET_PERIODS_BY_NAME_YEAR_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                successMessage: null,
            };

        case CLEAR_SELECTED_PERIOD:
            return {
                ...state,
                selectedPeriod: null,
            };

        default:
            return state;
    }
};

export default CalendarReducer;

